import React, { useState, useEffect } from 'react';
import { Typography, Row } from 'antd';
import { ModalAttendance } from '../../../../../components/ModalAttendance';

export function ModalExclusaoRazao({
  isModalVisible,
  setIsModalVisible,
  indexRazao,
  setRazoesReprovacao,
  razoesReprovacao,
}) {
  const { Text } = Typography;
  const [razao, setRazao] = useState();
  const handlerDeleteRazao = async index => {
    setRazoesReprovacao(razoesReprovacao.filter((_razao, i) => i !== index));
    setIsModalVisible(false);
  };

  const cancelModal = () => setIsModalVisible(!isModalVisible);

  const okModal = () => {
    setIsModalVisible(!isModalVisible);
    handlerDeleteRazao(indexRazao);
  };

  useEffect(() => {
    setRazao(razoesReprovacao.find((_razao, i) => i === indexRazao));
  }, [indexRazao]);

  return (
    <ModalAttendance
      title="Deseja excluir a razão abaixo?"
      visible={isModalVisible}
      cancelBtn={cancelModal}
      okBtn={okModal}
      subTitle={razao?.razao}
    />
  );
}
